import React from "react";

const NoDataFound = ({ title, icon }) => {
  return (
    <div className="no_data_found">
      {icon && <img src={icon} alt={title} width={120} height={120} />}
      <h2>{title}</h2>
    </div>
  );
};

export default NoDataFound;
